 
//export const backend_url = "http://localhost:3000/api/v1/";
export const backend_url = "https://app.cyprusmarineclub.org.cy:8888/api/v1/"; 


try{
    var user_data = JSON.parse(localStorage.getItem("user_data"))
    if(!user_data){
        user_data = {}
    }
}catch(e){ 
    var user_data = {}
}

function return_error(_this, add_errors){

    var errors = _this.state.errors

    if(!errors){
        errors = []
    }
    if(add_errors.length){
        errors = errors.concat(add_errors)
    }else{
        try{
            Object.keys(add_errors).forEach(k=>{
                console.log(typeof add_errors)
                console.log(add_errors)
                console.log(k)
                console.log(add_errors[k])
                add_errors[k].forEach(er=>{
                    errors.push(k+": "+er)
                })
            })
        }catch(e){
            console.log(add_errors)
            console.log(_this)
            console.log(e)
        }
    }

    _this.setState({
        errors: errors
    })

}

export function Rest(_this) { 

    this.login = function (login, password, callback=()=>{}) {
        var data = JSON.stringify({
            login: login,
            password: password,
        });
        fetch(backend_url + '/authentication', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: data,
        })
            .then((response) => {
                console.log(response)
                return response.json()
            })
            .then((rJson) => { 
                if (rJson && rJson.errors && rJson.errors.length) {
                    return_error(_this, rJson.errors) 
                    return
                } 
                callback(rJson)
            })
            .catch(() => {
                console.log("error something");
            });
    }; 


    this.get_file = function (url, params, name, callback=()=>{}) {
        url = backend_url + url
        if(url.indexOf("?")==-1){
            url += "?"
        }
        url += Object.keys(params).map(k=>{
            return k+"="+params[k]
        }).join("&")

        fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': user_data.token,
                'Content-Type': 'application/json'
            }
        })
            .then(resp => { 
                return resp.blob()
            })
            .then(blob => { 
                callback();
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = name;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            })
    }

    
    this.request = function (url, method, params, callback=()=>{}) { 
        url = backend_url + url
        if(method=="GET"){
            if(url.indexOf("?")==-1){
                url += "?"
            }

            url += Object.keys(params).map(k=>{
                return k+"="+params[k]
            }).join("&")
        }

        if(method == 'READ'){
            method = "GET"
            url += "/"+params.id
        }
        if(method == 'UPDATE'){
            method = "PUT"
            url += "/"+params.id
        }
        if(method == 'DELETE'){
            method = "DELETE"
            url += "/"+params.id
        }
        if(method == 'CREATE'){
            method = "POST"
        }
        
        if(!user_data.token){ 
            go_to_auth()
            return
        }else{

            if(method=="GET"){
                params = null
            }

            if(params){
                try{
                    params = JSON.stringify(params)
                }catch{

                }
            }
             var request_ok = false
            fetch(url, {
                method: method,
                headers: {
                    'Authorization': user_data.token,
                    'Content-Type': 'application/json'
                }, 
                body: params
            }).then((response) => {
                console.log(response)
                var rJson = response.json()
                request_ok = response.ok
                if(!request_ok){
                    
                    return_error(_this, ["Request error, code "+response.status])
                    
                    if(response.statusText == "Unauthorized"){
                        go_to_auth()
                        return
                    } 
                }
                return rJson
            }).then((rJson) => { 
                console.log(rJson)
                if (rJson && rJson.invalid_token) {
                    go_to_auth()
                    return
                } 
                if (rJson && rJson.errors && rJson.errors.length) {
                    return_error(_this, rJson.errors) 
                    return
                } 
                if(request_ok){
                    callback(rJson);
                }else{ 
                    return_error(_this, rJson) 
                }
            })
            .catch((e) => {

                return_error(_this, ["Request error "+e]) 
                
            });
    
        
        

        } 

    }
}

function go_to_auth(){
    if( window.location.href.indexOf("authentification") == -1 ){
        document.location.href = "/authentification"
    }
}